import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const Curriculum = () => {
     useEffect(() => {
        document.title = 'Curriculum -  Mary Matha Cmi  Academy';   
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
        <li><Link to="/"> Home</Link> </li> 
        <li>  School </li> 
        <li>Curriculum </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Curriculum  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
         <p>  We strictly follow the curriculum and syllabi in accordance with the specifications of the <b> CENTRAL BOARD OF SECONDARY EDUCATION (CBSE),</b> New Delhi and prepare the children for All India Secondary School Examination <b>(AISSE)</b> and All India Senior School Certificate Examination <b>(AISSCE)</b> .</p>
         <p> <b>English is the medium</b> of instruction in our school from primary to senior secondary level. Besides, <b>Tamil and Hindi </b> are offered, as the compulsory languages.</p>
        <h6>Extra-curricular Activities</h6>
          <p>Extra-curricular activities go hand-in-hand with academics at our school so as to develop a wholesome personality rich in values, culture and tolerance, along with robust mental and physical capabilities.</p>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default Curriculum
